import React from 'react'
import { Empty } from 'antd';
import styled from 'styled-components'

const Section = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`

const NullDataComp = () => {
    return (
        <Section>
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
            >
            </Empty>
        </Section>
    )
}

export default NullDataComp